unit JobDetailBaseForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  WEBLib.Lists,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  XData.Web.Dataset;

type
  TJobDetailBase = class(TCoreWebForm)
    PlaceJobButton: TButton;
    ErrorMessage: THTMLSpan;
    ErrorsButton: TButton;
    CompleteButton: TButton;
    CloseButton: TButton;
    WebMessageDlg1: TMessageDlg;
    DataSource: TDataSource;
    CompletedBy: TLabel;
    DateCompleted: TLabel;
    OwnedBy: TLabel;
    SubmittedBy: TLabel;
    DateSubmitted: TDBLabel;
    RunLevelLabel: TDBLabel;
    WebDBLabel4: TDBLabel;
    DateRun: TDBLabel;
    JobType: TLabel;
    FormCaption: TLabel;
    DownloadFiles: THTMLDiv;
    FileList: TListControl;
    JobProgress: THTMLSpan;
    ProgressTimer: TTimer;
    procedure CloseButtonClick(Sender: TObject);
    procedure CompleteButtonClick(Sender: TObject);
    procedure ErrorsButtonClick(Sender: TObject);
    [async]
    procedure FileListItemClick(Sender: TObject; AListItem: TListItem); async;
    procedure PlaceJobButtonClick(Sender: TObject);
    procedure ProgressTimerTimer(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
  private
    { Private declarations }
    FJobId: Integer;
    FCloseModal: TModalResult;
    FPollDataset: TXDataWebDataSet;
    FPolling: Boolean;
    procedure MarkCompleted;
    procedure SetDataset(const Value: TDataset);
    function ParseJSONOrDefault(const AJSON: string; const ADefaultJSON: string = '{}'): JS.TJSObject;
    [async]
    procedure GetUserDetails; async;
    procedure LoadErrorMessage;
    procedure SetDownloadsSectionVisible(AVisible: Boolean);
    [async]
    procedure LoadHMRCErrorSummary; async;
    function JobHasErrors: Boolean;
    function JobHasErrorFile: Boolean;
    function IsHMRCRelatedJob: Boolean;
    [async]
    procedure LoadFileList(AData: JS.TJSObject); async;
    [async]
    procedure SendJobForProduction; async;
    [async]
    procedure ShowErrors; async;
    procedure RefreshProgressDisplay; overload;
    procedure RefreshProgressDisplay(ADataset: TDataSet); overload;
    procedure StartProgressPolling;
    procedure StopProgressPolling;
    procedure EnsurePollDataset;
    procedure PollDatasetAfterOpen(DataSet: TDataSet);
    procedure CopyFieldIfPresent(ASource, ADest: TDataSet; const AFieldName: string);
    procedure ApplyCompletionMeta(ADataset: TDataSet);
    [async]
    procedure ShowErrorsIfNeeded; async;
  protected
    procedure LoadStats(AData: JS.TJSObject); virtual;
  public
    { Public declarations }
    property Dataset: TDataset write SetDataset;
  protected procedure LoadDFMValues; override; end;

var
  JobDetailBase: TJobDetailBase;

implementation

{$R *.dfm}

uses
  System.StrUtils,
  Auth.Service,
  MainDataModule,
  XData.Web.Client,
  MainForm,
  SMX.Web.Utils,
  SMX.Shared,
  JobErrorForm,
  SMX.Web.Service.Consts,
  SMX.Web.Jobs.Utils,
  SharedDataModule;

procedure TJobDetailBase.CloseButtonClick(Sender: TObject);
begin
  StopProgressPolling;
  ModalResult := FCloseModal;
end;

procedure TJobDetailBase.CompleteButtonClick(Sender: TObject);
begin
  MarkCompleted;
end;

procedure TJobDetailBase.ErrorsButtonClick(Sender: TObject);
begin
  ShowErrors;
end;

procedure TJobDetailBase.RefreshProgressDisplay;
begin
  if Assigned(DataSource.Dataset) then
    RefreshProgressDisplay(DataSource.Dataset);
end;

procedure TJobDetailBase.RefreshProgressDisplay(ADataset: TDataSet);
var
  lStatus, lRawStatus, lPctText, lDetail, lRemaining, lBarClass, lJobType, lTypeClass: string;
  lProgress: Double;
  lPct, lWidth: Integer;
  lJS: JS.TJSObject;
  lStatsField: TField;
  lStatsText: string;
  lEl: TJSHTMLElement;
  lActive: Boolean;
  lStalled: Boolean;

  procedure SetElText(const AId, AText: string);
  var
    el: TJSHTMLElement;
  begin
    el := TJSHTMLElement(document.getElementById(AId));
    if Assigned(el) then
      el.textContent := AText;
  end;

begin
  if not Assigned(ADataset) or (not ADataset.Active) or ADataset.IsEmpty then
    Exit;

  try
    lRawStatus := ADataset.FieldByName('Status').AsString;
  except
    Exit;
  end;

  lStalled := JobIsStalled(ADataset);
  if lStalled then
    lStatus := 'Stalled'
  else
    lStatus := lRawStatus;

  if Assigned(WebDBLabel4) then
    WebDBLabel4.Caption := UpperCase(lStatus);

  lProgress := 0;
  try
    if not ADataset.FieldByName('Progress').IsNull then
      lProgress := ADataset.FieldByName('Progress').AsFloat;
  except
    lProgress := 0;
  end;

  if lProgress <= 0 then
    lPct := 0
  else if lProgress >= 100 then
    lPct := 100
  else
    lPct := Trunc(lProgress);

  { Stopped jobs (Failed/Cancelled): full fill means processing has ended. Complete keeps real %. }
  if JobStatusIsStopped(lRawStatus) then
    lPct := 100;

  lActive := JobStatusIsActive(lRawStatus) or lStalled;
  if JobStatusIsStopped(lRawStatus) then
    lPctText := ''
  else if lProgress > 0 then
    lPctText := FormatJobProgress(lProgress)
  else
    lPctText := '';
  SetElText('JobProgressPct', lPctText);

  lDetail := '';
  lRemaining := '';
  { Detail/remaining filled from stats in LoadStats when available. }
  SetElText('JobProgressDetail', lDetail);
  SetElText('JobProgressRemaining', lRemaining);

  lJobType := '';
  try
    if Assigned(ADataset.FindField('JobType')) then
      lJobType := ADataset.FieldByName('JobType').AsString;
  except
    lJobType := '';
  end;
  lTypeClass := JobTypeCssClass(lJobType);

  lEl := TJSHTMLElement(document.getElementById('JobDetailHero'));
  if Assigned(lEl) then
  begin
    lEl.classList.remove('job-type-import', 'job-type-merge', 'job-type-prepare',
      'job-type-claim', 'job-type-markpaid', 'job-type-cancel', 'job-type-other',
      'is-processing', 'is-complete', 'is-stalled', 'is-failed',
      'is-cancelled', 'is-waiting');
    if lTypeClass <> '' then
      lEl.classList.add(lTypeClass);
    if lStalled then
      lEl.classList.add('is-stalled')
    else if SameText(lRawStatus, 'Complete') or SameText(lRawStatus, 'Processed') then
      lEl.classList.add('is-complete')
    else if SameText(lRawStatus, 'Cancelled') then
      lEl.classList.add('is-cancelled')
    else if SameText(lRawStatus, 'Failed') then
      lEl.classList.add('is-failed')
    else if lActive and (lPct <= 0) then
      lEl.classList.add('is-waiting')
    else if lActive then
      lEl.classList.add('is-processing');
  end;

  if Assigned(JobProgress) then
  begin
    if lStalled then
      lBarClass := 'progress-bar job-detail-bar-fill is-stalled'
    else if SameText(lRawStatus, 'Cancelled') then
      lBarClass := 'progress-bar job-detail-bar-fill is-cancelled'
    else if SameText(lRawStatus, 'Failed') then
      lBarClass := 'progress-bar job-detail-bar-fill is-failed'
    else if lPct >= 100 then
      lBarClass := 'progress-bar job-detail-bar-fill is-complete'
    else if lActive and (lPct <= 0) then
      lBarClass := 'progress-bar job-detail-bar-fill is-waiting'
    else if lActive then
      lBarClass := 'progress-bar job-detail-bar-fill is-processing'
    else
      lBarClass := 'progress-bar job-detail-bar-fill';

    lWidth := lPct;
    if (lPct > 0) and (lWidth < 2) then
      lWidth := 2;

    if JobStatusIsStopped(lRawStatus) or (lProgress > 0) or lActive then
      JobProgress.HTML.Text := Format(
        '<div class="progress job-detail-bar"><div class="%s" role="progressbar" ' +
        'style="width:%d%%" aria-valuenow="%d" aria-valuemin="0" aria-valuemax="100"></div></div>',
        [lBarClass, lWidth, lWidth])
    else
      JobProgress.HTML.Text := '';
  end;

  lStatsText := '{}';
  try
    lStatsField := ADataset.FindField('Stats');
    if Assigned(lStatsField) and (not lStatsField.IsNull) then
      lStatsText := lStatsField.AsString;
  except
    lStatsText := '{}';
  end;
  lJS := ParseJSONOrDefault(lStatsText);
  LoadStats(lJS);
  if JobStatusIsStopped(lRawStatus) then
  begin
    SetElText('JobProgressDetail', '');
    SetElText('JobProgressRemaining', '');
  end;
end;

procedure TJobDetailBase.StartProgressPolling;
var
  lActive: Boolean;
begin
  if not Assigned(ProgressTimer) then
    Exit;
  if (DataSource.Dataset = nil) or (not DataSource.Dataset.Active) or DataSource.Dataset.IsEmpty then
    Exit;

  { Always fetch once on open so Started/Completed catch up when the shared jobs
    row was soft-updated to Complete without those timestamps. }
  ProgressTimerTimer(nil);

  lActive := JobStatusIsActive(DataSource.Dataset.FieldByName('Status').AsString);
  ProgressTimer.Interval := 3000;
  ProgressTimer.Enabled := lActive;
end;

procedure TJobDetailBase.StopProgressPolling;
begin
  if Assigned(ProgressTimer) then
    ProgressTimer.Enabled := False;
  FPolling := False;
end;

procedure TJobDetailBase.EnsurePollDataset;
begin
  if Assigned(FPollDataset) then
    Exit;

  FPollDataset := TXDataWebDataSet.Create(Self);
  FPollDataset.EntitySetName := 'Job';
  FPollDataset.AfterOpen := PollDatasetAfterOpen;
  if Assigned(SharedData) and Assigned(SharedData.JobsDataset) then
    FPollDataset.Connection := SharedData.JobsDataset.Connection;
end;

procedure TJobDetailBase.CopyFieldIfPresent(ASource, ADest: TDataSet; const AFieldName: string);
var
  lSourceField, lDestField: TField;
begin
  if (not Assigned(ASource)) or (not Assigned(ADest)) then
    Exit;
  lSourceField := ASource.FindField(AFieldName);
  lDestField := ADest.FindField(AFieldName);
  if (not Assigned(lSourceField)) or (not Assigned(lDestField)) then
    Exit;
  { Never wipe an existing local value with a null poll payload. }
  if lSourceField.IsNull then
    Exit;
  case lSourceField.DataType of
    ftString, ftWideString, ftMemo, ftWideMemo:
      lDestField.AsString := lSourceField.AsString;
    ftInteger, ftSmallint, ftLargeint, ftWord:
      lDestField.AsInteger := lSourceField.AsInteger;
    ftFloat, ftCurrency, ftSingle, ftExtended:
      lDestField.AsFloat := lSourceField.AsFloat;
    ftBoolean:
      lDestField.AsBoolean := lSourceField.AsBoolean;
    ftDate, ftTime, ftDateTime, ftTimeStamp:
      lDestField.AsDateTime := lSourceField.AsDateTime;
  else
    lDestField.Value := lSourceField.Value;
  end;
end;

procedure TJobDetailBase.ApplyCompletionMeta(ADataset: TDataSet);
var
  lStatus: string;
  lEl: TJSHTMLElement;
begin
  if (not Assigned(ADataset)) or (not ADataset.Active) or ADataset.IsEmpty then
    Exit;

  lStatus := ADataset.FieldByName('Status').AsString;

  if (lStatus = 'Complete') or (lStatus = 'Cancelled') or (lStatus = 'NothingToDo') then
  begin
    if Assigned(ADataset.FindField('DateCompleted')) and
      (not ADataset.FieldByName('DateCompleted').IsNull) then
      DateCompleted.Caption := FormatDateTime('dd/mm/yyyy hh:nn:ss',
        ADataset.FieldByName('DateCompleted').AsDateTime)
    else
      DateCompleted.Caption := '—';
  end;

  lEl := TJSHTMLElement(document.getElementById('CompletedMeta'));
  if Assigned(lEl) then
  begin
    if (lStatus = 'Complete') or (lStatus = 'Processed') or (lStatus = 'Cancelled') or
      (lStatus = 'NothingToDo') then
      lEl.style.setProperty('display', '')
    else
      lEl.style.setProperty('display', 'none');
  end;

  lEl := TJSHTMLElement(document.getElementById('CompletedMetaLabel'));
  if Assigned(lEl) then
  begin
    if lStatus = 'Cancelled' then
      lEl.textContent := 'Cancelled'
    else
      lEl.textContent := 'Completed';
  end;
end;

procedure TJobDetailBase.PollDatasetAfterOpen(DataSet: TDataSet);
var
  lStatus: string;
  lProgress: Double;
  lStats, lDownloads: string;
  lJS: JS.TJSObject;
begin
  try
    if (not Assigned(FPollDataset)) or (not FPollDataset.Active) or FPollDataset.IsEmpty then
      Exit;

    RefreshProgressDisplay(FPollDataset);

    { Soft-update the shared row so the dashboard stays in sync without Close/Load. }
    if Assigned(SharedData) and SharedData.JobsDataset.Active and
      (not SharedData.JobsDataset.IsEmpty) then
    begin
      try
        lStatus := FPollDataset.FieldByName('Status').AsString;
        lProgress := 0;
        if not FPollDataset.FieldByName('Progress').IsNull then
          lProgress := FPollDataset.FieldByName('Progress').AsFloat;
        lStats := '';
        if Assigned(FPollDataset.FindField('Stats')) and (not FPollDataset.FieldByName('Stats').IsNull) then
          lStats := FPollDataset.FieldByName('Stats').AsString;
        lDownloads := '';
        if Assigned(FPollDataset.FindField('Downloads')) and (not FPollDataset.FieldByName('Downloads').IsNull) then
          lDownloads := FPollDataset.FieldByName('Downloads').AsString;

        if SharedData.JobsDataset.Locate('Id', FJobId, []) then
        begin
          SharedData.JobsDataset.Edit;
          SharedData.JobsDataset.FieldByName('Status').AsString := lStatus;
          SharedData.JobsDataset.FieldByName('Progress').AsFloat := lProgress;
          if lStats <> '' then
            SharedData.JobsDataset.FieldByName('Stats').AsString := lStats;
          if lDownloads <> '' then
            SharedData.JobsDataset.FieldByName('Downloads').AsString := lDownloads;
          CopyFieldIfPresent(FPollDataset, SharedData.JobsDataset, 'LastUpdated');
          CopyFieldIfPresent(FPollDataset, SharedData.JobsDataset, 'DateRun');
          CopyFieldIfPresent(FPollDataset, SharedData.JobsDataset, 'DateCompleted');
          CopyFieldIfPresent(FPollDataset, SharedData.JobsDataset, 'TimeTaken');
          CopyFieldIfPresent(FPollDataset, SharedData.JobsDataset, 'CompletedBy');
          SharedData.JobsDataset.Post;
        end;
      except
        { Ignore soft-update failures if the shared dataset is mid-refresh. }
      end;
    end;

    { Keep the open detail row aligned with polled terminal dates/status. }
    if Assigned(DataSource.Dataset) and DataSource.Dataset.Active then
    begin
      try
        if not (DataSource.Dataset.State in dsEditModes) then
          DataSource.Dataset.Edit;
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'Status');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'Progress');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'Stats');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'DateRun');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'DateCompleted');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'TimeTaken');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'CompletedBy');
        CopyFieldIfPresent(FPollDataset, DataSource.Dataset, 'LastUpdated');
        if Assigned(FPollDataset.FindField('Downloads')) and
          (not FPollDataset.FieldByName('Downloads').IsNull) then
        begin
          lDownloads := FPollDataset.FieldByName('Downloads').AsString;
          if (lDownloads <> '') and
            (DataSource.Dataset.FieldByName('Downloads').AsString <> lDownloads) then
          begin
            DataSource.Dataset.FieldByName('Downloads').AsString := lDownloads;
            lJS := ParseJSONOrDefault(lDownloads, '{"value": []}');
            LoadFileList(lJS);
          end;
        end;
        if Assigned(FPollDataset.FindField('Stats')) and
          (not FPollDataset.FieldByName('Stats').IsNull) then
        begin
          lStats := FPollDataset.FieldByName('Stats').AsString;
          if lStats <> '' then
          begin
            DataSource.Dataset.FieldByName('Stats').AsString := lStats;
            LoadStats(ParseJSONOrDefault(lStats));
          end;
        end;
        DataSource.Dataset.Post;
      except
      end;
    end;

    ApplyCompletionMeta(FPollDataset);

    if not JobStatusIsActive(FPollDataset.FieldByName('Status').AsString) then
    begin
      StopProgressPolling;
      { Merge completion creates unclaimed donations — refresh Submit Claim affordances. }
      if Assigned(MainPage) then
        MainPage.CheckCanPrepareClaims;
    end;
  finally
    FPolling := False;
  end;
end;

procedure TJobDetailBase.ProgressTimerTimer(Sender: TObject);
begin
  if FJobId <= 0 then
  begin
    StopProgressPolling;
    Exit;
  end;

  { Never call SharedData.LoadJobs here — Close() leaves JobsDataset inactive and
    races with dashboard clicks (inactive dataset / GetJSONDataForField errors). }
  if FPolling then
    Exit;

  EnsurePollDataset;
  if not Assigned(FPollDataset) or (FPollDataset.Connection = nil) then
    Exit;

  FPolling := True;
  try
    FPollDataset.Close;
    FPollDataset.QueryString := Format('$filter=Id eq %d', [FJobId]);
    FPollDataset.Load;
  except
    FPolling := False;
  end;
end;

procedure TJobDetailBase.WebFormDestroy(Sender: TObject);
begin
  StopProgressPolling;
  if Assigned(FPollDataset) then
  begin
    FPollDataset.AfterOpen := nil;
    FPollDataset.Close;
  end;
  inherited;
end;

procedure TJobDetailBase.FileListItemClick(Sender: TObject; AListItem: TListItem);
var
  lDownloads, lName, lFile, lBase64, lMime: string;
  lJS, jItem: JS.TJSObject;
  aJS: JS.TJSArray;
  I: Integer;
  lCount, lDownloaded: Integer;
  lCompleteEnabled: Boolean;
  lRetval: TXDataClientResponse;
  lExt: string;
begin
  lCompleteEnabled := CompleteButton.Enabled;
  CompleteButton.Enabled := False;

  lDownloads := DataSource.Dataset.FieldByName('Downloads').AsString;

  lJS := JS.TJSJSON.parseObject(lDownloads);

  aJS := JS.toArray(lJS['value']);
  if aJS = nil then
  begin
    CompleteButton.Enabled := lCompleteEnabled;
    Exit;
  end;
  lFile := '';
  lName := '';
  lCount := 0;
  lDownloaded := 0;
  for I := 0 to aJS.Length - 1 do
  begin
    jItem := JS.toObject(aJS[I]);
    lName := JS.toString(jItem['Name']);

    if lName = AListItem.Text then
    begin
      if jItem.hasOwnProperty('DownloadCount') then
        lCount := JS.toInteger(jItem['DownloadCount'])
      else
        lCount := 0;
      jItem['DownloadCount'] := lCount + 1;
      jItem['LastDownloadedBy'] := AuthService.InternalUserId;
      lFile := JS.toString(jItem['File']);
      lDownloaded := lDownloaded + 1;
    end
    else
    begin
      if jItem.hasOwnProperty('DownloadCount') and (JS.toInteger(jItem['DownloadCount']) > 0) then
        lDownloaded := lDownloaded + 1;
    end;
  end;

  if lFile <> '' then
  begin
    DataSource.Dataset.Edit;
    DataSource.Dataset.FieldByName('Downloads').AsString := JS.TJSJSON.stringify(lJS);
    if lDownloaded = aJS.Length then
    begin
      CompleteButton.Enabled := lCompleteEnabled;
      MarkCompleted;
    end
    else
    begin
      DataSource.Dataset.Post;
      CompleteButton.Enabled := lCompleteEnabled;
    end;

    try
      lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_GETFILE,
        [FJobId, lFile]));
      lBase64 := '';
      if Assigned(lRetval) and Assigned(lRetval.ResultAsObject) then
      begin
        if lRetval.ResultAsObject.hasOwnProperty('value') then
          lBase64 := JS.toString(lRetval.ResultAsObject['value']);
      end;
      if Trim(lBase64) = '' then
      begin
        ShowAToast('Download', 'Could not download ' + AListItem.Text, 'clock.png');
        Exit;
      end;

      lExt := LowerCase(ExtractFileExt(lFile));
      if lExt = '.pdf' then
        lMime := 'application/pdf'
      else if (lExt = '.csv') or (lExt = '.txt') then
        lMime := 'text/csv'
      else if lExt = '.json' then
        lMime := 'application/json'
      else if lExt = '.zip' then
        lMime := 'application/zip'
      else
        lMime := 'application/octet-stream';

      asm
        var byteChars = atob(lBase64);
        var byteNumbers = new Array(byteChars.length);
        for (var i = 0; i < byteChars.length; i++) {
          byteNumbers[i] = byteChars.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: lMime });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = AListItem.Text || lFile;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      end;
    except
      on E: Exception do
        ShowAToast('Download', E.Message, 'clock.png');
    end;
  end
  else
    CompleteButton.Enabled := lCompleteEnabled;
end;

procedure TJobDetailBase.GetUserDetails;
var
  lRetval: TXDataClientResponse;
  lResult: TJSObject;
  lS, lO, lC: Integer;
begin

  lS := DataSource.Dataset.FieldByName('SubmittedBy').AsInteger;
  lO := DataSource.Dataset.FieldByName('OwnedBy').AsInteger;
  lC := DataSource.Dataset.FieldByName('CompletedBy').AsInteger;

{$IFDEF STANDALONE}
  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_USERS, [lS, lO, lC]));
{$ELSE}
  { TODO : Needs to call to Sphinx (via server or direct?) }
  lRetval := nil;
{$ENDIF}
  if not Assigned(lRetval) then
    Exit;

  lResult := lRetval.ResultAsObject;

  SubmittedBy.Caption := JS.toString(lResult['SubmittedBy']);
  OwnedBy.Caption := JS.toString(lResult['OwnedBy']);

  if lC > 0 then
    CompletedBy.Caption := JS.toString(lResult['CompletedBy']);

end;

procedure TJobDetailBase.LoadErrorMessage;
var
  lJS: JS.TJSObject;
  lMessage: string;
begin
  lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Data').AsString);
  { Jobs write Failed Reason / Wait Reason; Exception is legacy. }
  lMessage := Trim(JS.toString(lJS['Exception']));
  if lMessage = '' then
    lMessage := Trim(JS.toString(lJS['Failed Reason']));
  if lMessage = '' then
    lMessage := Trim(JS.toString(lJS['Wait Reason']));

  if lMessage <> '' then
    ErrorMessage.HTML.Text := lMessage
  else if JobHasErrors then
  begin
    if JobHasErrorFile then
    begin
      if IsHMRCRelatedJob then
        ErrorMessage.HTML.Text :=
          'This job completed with errors. Use the Errors button to view HMRC response details.'
      else
        ErrorMessage.HTML.Text :=
          'This job completed with errors. Use the Errors button to view error details.';
    end
    else
      ErrorMessage.HTML.Text := 'This job completed with errors.';
  end;
  ErrorMessage.Visible := ErrorMessage.HTML.Text <> '';
end;

function TJobDetailBase.JobHasErrors: Boolean;
begin
  Result := False;
  if DataSource.Dataset = nil then
    Exit;
  if DataSource.Dataset.FindField('HasErrors') = nil then
    Exit;
  if DataSource.Dataset.FieldByName('HasErrors').IsNull then
    Exit;
  Result := DataSource.Dataset.FieldByName('HasErrors').AsBoolean;
end;

function TJobDetailBase.JobHasErrorFile: Boolean;
var
  lJS: JS.TJSObject;
begin
  Result := False;
  if DataSource.Dataset = nil then
    Exit;
  if DataSource.Dataset.FindField('Data') = nil then
    Exit;
  lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Data').AsString);
  Result := Trim(JS.toString(lJS['ErrorFile'])) <> '';
end;

function TJobDetailBase.IsHMRCRelatedJob: Boolean;
var
  lJobType: string;
begin
  Result := False;
  if DataSource.Dataset = nil then
    Exit;
  if DataSource.Dataset.FindField('JobType') = nil then
    Exit;
  lJobType := DataSource.Dataset.FieldByName('JobType').AsString;
  Result := ContainsText(lJobType, 'GiftAidClaim') or ContainsText(lJobType, 'ClaimGiftAid') or
    ContainsText(lJobType, 'PrepareClaim') or ContainsText(lJobType, 'MarkPaid') or
    ContainsText(lJobType, 'Poll');
end;

procedure TJobDetailBase.LoadHMRCErrorSummary;
var
  lRetval: TXDataClientResponse;
  lJS, lDataJS: JS.TJSObject;
  aJS: JS.TJSArray;
  lFirstError, lErrorJson: string;
begin
  if not JobHasErrors then
    Exit;

  lDataJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Data').AsString);
  if not lDataJS.hasOwnProperty('ErrorFile') then
    Exit;

{$IFDEF STANDALONE}
  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_GETERRORFILE,
    [DataSource.Dataset.FieldByName('Id').AsInteger]));
{$ELSE}
  lRetval := nil;
{$ENDIF}
  if not Assigned(lRetval) or not Assigned(lRetval.ResultAsObject) then
    Exit;

  try
    lErrorJson := JS.toString(lRetval.ResultAsObject['value']);
    if lErrorJson = '' then
      Exit;

    aJS := JS.toArray(JS.TJSJSON.parse(lErrorJson));
    if (aJS <> nil) and (aJS.Length > 0) then
    begin
      lJS := JS.toObject(aJS[0]);
      lFirstError := JS.toString(lJS['error']);
      if lFirstError <> '' then
        ErrorMessage.HTML.Text := lFirstError;
      ErrorMessage.Visible := True;
    end;
  except
  end;
end;

procedure TJobDetailBase.SetDownloadsSectionVisible(AVisible: Boolean);
var
  lJobData: TJSHTMLElement;
begin
  DownloadFiles.Visible := AVisible;
  lJobData := TJSHTMLElement(document.getElementById('JobData'));
  if Assigned(lJobData) then
  begin
    if AVisible then
      lJobData.style.removeProperty('display')
    else
      lJobData.style.setProperty('display', 'none');
  end;
end;

procedure TJobDetailBase.LoadFileList(AData: JS.TJSObject);
var
  lDownloads, lName: string;
  jItem: JS.TJSObject;
  aJS: JS.TJSArray;
  I: Integer;
  lItem: TListItem;
  lHasFiles: Boolean;
begin
  FileList.Items.Clear;
  SetDownloadsSectionVisible(False);
  lHasFiles := False;

  lDownloads := Trim(DataSource.Dataset.FieldByName('Downloads').AsString);
  if (lDownloads = '') or (lDownloads = '{}') or (lDownloads = '{"value":[]}') then
    Exit;

  if not Assigned(AData) then
    Exit;

  aJS := JS.toArray(AData['value']);
  if (aJS = nil) or (aJS.Length = 0) then
    Exit;

  for I := 0 to aJS.Length - 1 do
  begin
    jItem := JS.toObject(aJS[I]);
    if not Assigned(jItem) then
      Continue;
    lName := Trim(JS.toString(jItem['Name']));
    if lName = '' then
      Continue;

    lItem := FileList.Items.Add;
    lItem.Text := lName;
    lHasFiles := True;
  end;

  SetDownloadsSectionVisible(lHasFiles);
end;

procedure TJobDetailBase.LoadStats(AData: JS.TJSObject);
begin

end;

procedure TJobDetailBase.MarkCompleted;
begin
  if DataSource.Dataset.FieldByName('Status').AsString = 'Complete' then
    Exit;

  DataSource.Dataset.DisableControls;
  try
    if not(DataSource.State in dsEditModes) then
      DataSource.Dataset.Edit;
    DataSource.Dataset.FieldByName('Status').AsString := 'Complete';
    DataSource.Dataset.FieldByName('CompletedBy').AsInteger := AuthService.InternalUserId;
    DataSource.Dataset.FieldByName('DateCompleted').AsDateTime := Now;
    DataSource.Dataset.Post;

    CompletedBy.Caption := AuthService.UserFullName;
    DateCompleted.Caption := FormatDateTime('dd/mm/yyyy hh:nn:ss', Now);
    CompleteButton.Visible := False;
  finally
    DataSource.Dataset.EnableControls;
  end;
  FCloseModal := mrOK;
end;

function TJobDetailBase.ParseJSONOrDefault(const AJSON: string; const ADefaultJSON: string): JS.TJSObject;
var
  lJSON: string;
begin
  lJSON := Trim(AJSON);
  if lJSON = '' then
    lJSON := ADefaultJSON;

  try
    Result := JS.TJSJSON.parseObject(lJSON);
  except
    Result := JS.TJSJSON.parseObject(ADefaultJSON);
  end;
end;

procedure TJobDetailBase.PlaceJobButtonClick(Sender: TObject);
begin
  SendJobForProduction;
end;

procedure TJobDetailBase.SendJobForProduction;
var
  lParams, lJobClass, lJobVisibility, lOutput: string;
  lRetval: TXDataClientResponse;
begin
  lParams := DataSource.Dataset.FieldByName('Data').AsString;
  lJobClass := DataSource.Dataset.FieldByName('JobType').AsString;
  lJobVisibility := DataSource.Dataset.FieldByName('Visibility').AsString;
  lOutput := DataSource.Dataset.FieldByName('OutputOption').AsString;

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_SCHEDULEJOB,
    [lJobClass, lJobVisibility, lParams, lOutput, 'Production']));

  ShowAToast(DataSource.Dataset.FieldByName('Title').AsString, 'Your job has been sent for production', 'clock.png');

  PlaceJobButton.Visible := False;

  MarkCompleted;
end;

procedure TJobDetailBase.SetDataset(const Value: TDataset);
var
  lStatus, S: string;
  lJS: JS.TJSObject;
  lEl: TJSHTMLElement;
  lHasErrors: Boolean;
begin
  StopProgressPolling;
  DataSource.Dataset := Value;
  FJobId := Value.FieldByName('Id').AsInteger;
  FormCaption.Caption := Value.FieldByName('Title').AsString;
  lEl := TJSHTMLElement(document.getElementById('JobIdBadge'));
  if Assigned(lEl) then
    lEl.textContent := 'Job #' + IntToStr(FJobId);

  JobType.Caption := TUtils.SplitOnCaps(DataSource.Dataset.FieldByName('JobType').AsString.Substring(1));

  lStatus := DataSource.Dataset.FieldByName('Status').AsString;
  lHasErrors := JobHasErrors;

  CompleteButton.Visible := (lStatus = 'Processed') or (lStatus = 'Preview');
  CompleteButton.Enabled := CompleteButton.Visible;

  ApplyCompletionMeta(Value);

  if (lStatus = 'Failed') or (lStatus = 'Cancelled') or lHasErrors then
  begin
    if lStatus = 'Failed' then
    begin
      lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Data').AsString);
      LoadErrorMessage;
      LoadHMRCErrorSummary;
      LoadStats(lJS);
    end
    else if lStatus = 'Cancelled' then
    begin
      lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Stats').AsString);
      LoadStats(lJS);
    end
    else
    begin
      lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Data').AsString);
      LoadErrorMessage;
      LoadHMRCErrorSummary;
    end;
  end
  else
  begin
    PlaceJobButton.Visible := lStatus = 'Preview';

    lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Stats').AsString);
    LoadStats(lJS);
  end;

  { Always driven by Downloads JSON — hide the whole section when empty. }
  lJS := ParseJSONOrDefault(DataSource.Dataset.FieldByName('Downloads').AsString, '{"value": []}');
  LoadFileList(lJS);

  RefreshProgressDisplay;
  { Errors opens the job ErrorFile JSON viewer — only when one exists. }
  ErrorsButton.Visible := JobHasErrorFile;

  try
    GetUserDetails;
  except
  end;

  StartProgressPolling;
end;

procedure TJobDetailBase.ShowErrorsIfNeeded;
begin
  if JobHasErrorFile then
    ShowErrors;
end;

procedure TJobDetailBase.ShowErrors;
var
  AForm: TJobErrors;
begin
  AForm := TJobErrors.Create(Self);
  try
    AForm.ElementClassName := 'PopUpForm job-errors-popup';
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    await(TJobErrors, AForm.Load());
    try
      await(AForm.LoadJobErrors(FJobId));
      await(TModalResult, AForm.Execute);
    except
      on E: Exception do
      begin
        if (Pos('No error file', E.Message) > 0) or
          (Pos('file was not found', E.Message) > 0) then
        begin
          AForm.ShowNoErrorFile;
          await(TModalResult, AForm.Execute);
        end
        else
          ShowAToast('Errors', 'Could not load the error file: ' + E.Message, 'fad fa-bug');
      end;
    end;
  finally
    AForm.Free;
    AForm := nil;
  end;

end;

procedure TJobDetailBase.WebFormCreate(Sender: TObject);
begin
  inherited;
  { Let CSS target this popup without relying solely on :has() support quirks. }
  ElementClassName := 'PopUpForm job-detail-popup';
  SubmittedBy.Caption := ' ';
  OwnedBy.Caption := ' ';
  CompletedBy.Caption := ' ';
  DateCompleted.Caption := ' ';
  FCloseModal := mrClose;
  FJobId := 0;
  FPolling := False;
  FPollDataset := nil;

  if not Assigned(JobProgress) then
  begin
    JobProgress := THTMLSpan.Create(Self);
    JobProgress.Parent := Self;
    JobProgress.ElementID := 'JobProgress';
    JobProgress.ElementPosition := epIgnore;
    JobProgress.HeightStyle := ssAuto;
    JobProgress.WidthStyle := ssAuto;
  end;

  if not Assigned(ProgressTimer) then
  begin
    ProgressTimer := TTimer.Create(Self);
    ProgressTimer.Enabled := False;
    ProgressTimer.Interval := 3000;
    ProgressTimer.OnTimer := ProgressTimerTimer;
  end;
end;

procedure TJobDetailBase.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CompletedBy := TLabel.Create('CompletedBy');
  DateCompleted := TLabel.Create('DateCompleted');
  OwnedBy := TLabel.Create('OwnedBy');
  SubmittedBy := TLabel.Create('SubmittedBy');
  DateSubmitted := TDBLabel.Create('DateSubmitted');
  RunLevelLabel := TDBLabel.Create('RunLevel');
  WebDBLabel4 := TDBLabel.Create('JobStatus');
  DateRun := TDBLabel.Create('DateRun');
  JobType := TLabel.Create('JobType');
  FormCaption := TLabel.Create('FormCaption');
  PlaceJobButton := TButton.Create('PlaceJobButton');
  ErrorMessage := THTMLSpan.Create('JobErrorMessage');
  ErrorsButton := TButton.Create('ErrorsButton');
  CompleteButton := TButton.Create('CompleteButton');
  CloseButton := TButton.Create('CloseButton');
  WebMessageDlg1 := TMessageDlg.Create(Self);
  DownloadFiles := THTMLDiv.Create('DownloadFiles');
  FileList := TListControl.Create('FileList');
  DataSource := TDataSource.Create(Self);

  CompletedBy.BeforeLoadDFMValues;
  DateCompleted.BeforeLoadDFMValues;
  OwnedBy.BeforeLoadDFMValues;
  SubmittedBy.BeforeLoadDFMValues;
  DateSubmitted.BeforeLoadDFMValues;
  RunLevelLabel.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  DateRun.BeforeLoadDFMValues;
  JobType.BeforeLoadDFMValues;
  FormCaption.BeforeLoadDFMValues;
  PlaceJobButton.BeforeLoadDFMValues;
  ErrorMessage.BeforeLoadDFMValues;
  ErrorsButton.BeforeLoadDFMValues;
  CompleteButton.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  DownloadFiles.BeforeLoadDFMValues;
  FileList.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    ElementClassName := 'PopUpForm job-detail-popup';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    CompletedBy.SetParentComponent(Self);
    CompletedBy.Name := 'CompletedBy';
    CompletedBy.Left := 176;
    CompletedBy.Top := 162;
    CompletedBy.Width := 72;
    CompletedBy.Height := 15;
    CompletedBy.Caption := 'CompletedBy';
    CompletedBy.ElementFont := efCSS;
    CompletedBy.ElementPosition := epIgnore;
    CompletedBy.HeightStyle := ssAuto;
    CompletedBy.HeightPercent := 100.000000000000000000;
    CompletedBy.HTMLType := tSPAN;
    CompletedBy.WidthPercent := 100.000000000000000000;
    DateCompleted.SetParentComponent(Self);
    DateCompleted.Name := 'DateCompleted';
    DateCompleted.Left := 91;
    DateCompleted.Top := 162;
    DateCompleted.Width := 83;
    DateCompleted.Height := 15;
    DateCompleted.Caption := 'DateCompleted';
    DateCompleted.ElementFont := efCSS;
    DateCompleted.ElementPosition := epIgnore;
    DateCompleted.HeightStyle := ssAuto;
    DateCompleted.HeightPercent := 100.000000000000000000;
    DateCompleted.HTMLType := tSPAN;
    DateCompleted.WidthStyle := ssAuto;
    DateCompleted.WidthPercent := 100.000000000000000000;
    OwnedBy.SetParentComponent(Self);
    OwnedBy.Name := 'OwnedBy';
    OwnedBy.Left := 224;
    OwnedBy.Top := 91;
    OwnedBy.Width := 51;
    OwnedBy.Height := 15;
    OwnedBy.Caption := 'OwnedBy';
    OwnedBy.ElementFont := efCSS;
    OwnedBy.ElementPosition := epIgnore;
    OwnedBy.HeightStyle := ssAuto;
    OwnedBy.HeightPercent := 100.000000000000000000;
    OwnedBy.HTMLType := tSPAN;
    OwnedBy.WidthPercent := 100.000000000000000000;
    SubmittedBy.SetParentComponent(Self);
    SubmittedBy.Name := 'SubmittedBy';
    SubmittedBy.Left := 224;
    SubmittedBy.Top := 72;
    SubmittedBy.Width := 68;
    SubmittedBy.Height := 15;
    SubmittedBy.Caption := 'SubmittedBy';
    SubmittedBy.ElementFont := efCSS;
    SubmittedBy.HeightStyle := ssAuto;
    SubmittedBy.HeightPercent := 100.000000000000000000;
    SubmittedBy.HTMLType := tSPAN;
    SubmittedBy.WidthPercent := 100.000000000000000000;
    DateSubmitted.SetParentComponent(Self);
    DateSubmitted.Name := 'DateSubmitted';
    DateSubmitted.Left := 96;
    DateSubmitted.Top := 72;
    DateSubmitted.Width := 79;
    DateSubmitted.Height := 15;
    DateSubmitted.Caption := 'DateSubmitted';
    DateSubmitted.ElementFont := efCSS;
    DateSubmitted.ElementPosition := epIgnore;
    DateSubmitted.HeightStyle := ssAuto;
    DateSubmitted.HeightPercent := 100.000000000000000000;
    DateSubmitted.HTMLType := tSPAN;
    DateSubmitted.WidthPercent := 100.000000000000000000;
    DateSubmitted.DataField := 'DateSubmitted';
    DateSubmitted.DataSource := DataSource;
    RunLevelLabel.SetParentComponent(Self);
    RunLevelLabel.Name := 'RunLevelLabel';
    RunLevelLabel.Left := 336;
    RunLevelLabel.Top := 46;
    RunLevelLabel.Width := 48;
    RunLevelLabel.Height := 15;
    RunLevelLabel.Caption := 'RunLevel';
    RunLevelLabel.ElementFont := efCSS;
    RunLevelLabel.ElementPosition := epIgnore;
    RunLevelLabel.HeightStyle := ssAuto;
    RunLevelLabel.HeightPercent := 100.000000000000000000;
    RunLevelLabel.HTMLType := tSPAN;
    RunLevelLabel.WidthPercent := 100.000000000000000000;
    RunLevelLabel.DataField := 'RunLevel';
    RunLevelLabel.DataSource := DataSource;
    WebDBLabel4.SetParentComponent(Self);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 248;
    WebDBLabel4.Top := 46;
    WebDBLabel4.Width := 50;
    WebDBLabel4.Height := 15;
    WebDBLabel4.Caption := 'JobStatus';
    WebDBLabel4.ElementFont := efCSS;
    WebDBLabel4.ElementPosition := epIgnore;
    WebDBLabel4.HeightStyle := ssAuto;
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.HTMLType := tSPAN;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.DataField := 'Status';
    WebDBLabel4.DataSource := DataSource;
    DateRun.SetParentComponent(Self);
    DateRun.Name := 'DateRun';
    DateRun.Left := 176;
    DateRun.Top := 46;
    DateRun.Width := 45;
    DateRun.Height := 15;
    DateRun.Caption := 'DateRun';
    DateRun.ElementFont := efCSS;
    DateRun.ElementPosition := epIgnore;
    DateRun.HeightStyle := ssAuto;
    DateRun.HeightPercent := 100.000000000000000000;
    DateRun.HTMLType := tSPAN;
    DateRun.WidthPercent := 100.000000000000000000;
    DateRun.DataField := 'DateRun';
    DateRun.DataSource := DataSource;
    JobType.SetParentComponent(Self);
    JobType.Name := 'JobType';
    JobType.Left := 88;
    JobType.Top := 48;
    JobType.Width := 43;
    JobType.Height := 15;
    JobType.Caption := 'JobType';
    JobType.ElementFont := efCSS;
    JobType.HeightStyle := ssAuto;
    JobType.HeightPercent := 100.000000000000000000;
    JobType.HTMLType := tSPAN;
    JobType.WidthPercent := 100.000000000000000000;
    FormCaption.SetParentComponent(Self);
    FormCaption.Name := 'FormCaption';
    FormCaption.Left := 48;
    FormCaption.Top := 8;
    FormCaption.Width := 73;
    FormCaption.Height := 15;
    FormCaption.Caption := 'Form Caption';
    FormCaption.ElementClassName := 'HeadlineClass';
    FormCaption.ElementFont := efCSS;
    FormCaption.ElementPosition := epIgnore;
    FormCaption.HeightStyle := ssAuto;
    FormCaption.HeightPercent := 100.000000000000000000;
    FormCaption.HTMLType := tDIV;
    FormCaption.WidthStyle := ssAuto;
    FormCaption.WidthPercent := 100.000000000000000000;
    PlaceJobButton.SetParentComponent(Self);
    PlaceJobButton.Name := 'PlaceJobButton';
    PlaceJobButton.Left := 432;
    PlaceJobButton.Top := 256;
    PlaceJobButton.Width := 96;
    PlaceJobButton.Height := 25;
    PlaceJobButton.Caption := 'Place Job';
    PlaceJobButton.ChildOrder := 17;
    PlaceJobButton.ElementClassName := 'btn btn-light';
    PlaceJobButton.ElementFont := efCSS;
    PlaceJobButton.ElementPosition := epIgnore;
    PlaceJobButton.HeightStyle := ssAuto;
    PlaceJobButton.HeightPercent := 100.000000000000000000;
    PlaceJobButton.Visible := False;
    PlaceJobButton.WidthStyle := ssAuto;
    PlaceJobButton.WidthPercent := 100.000000000000000000;
    SetEvent(PlaceJobButton, Self, 'OnClick', 'PlaceJobButtonClick');
    ErrorMessage.SetParentComponent(Self);
    ErrorMessage.Name := 'ErrorMessage';
    ErrorMessage.Left := 96;
    ErrorMessage.Top := 272;
    ErrorMessage.Width := 100;
    ErrorMessage.Height := 41;
    ErrorMessage.HeightStyle := ssAuto;
    ErrorMessage.WidthStyle := ssAuto;
    ErrorMessage.ChildOrder := 13;
    ErrorMessage.ElementPosition := epIgnore;
    ErrorMessage.ElementFont := efCSS;
    ErrorMessage.Role := '';
    ErrorMessage.Visible := False;
    ErrorsButton.SetParentComponent(Self);
    ErrorsButton.Name := 'ErrorsButton';
    ErrorsButton.Left := 304;
    ErrorsButton.Top := 256;
    ErrorsButton.Width := 96;
    ErrorsButton.Height := 25;
    ErrorsButton.Caption := 'Errors';
    ErrorsButton.ChildOrder := 15;
    ErrorsButton.ElementClassName := 'btn btn-warning';
    ErrorsButton.ElementFont := efCSS;
    ErrorsButton.ElementPosition := epIgnore;
    ErrorsButton.HeightStyle := ssAuto;
    ErrorsButton.HeightPercent := 100.000000000000000000;
    ErrorsButton.WidthStyle := ssAuto;
    ErrorsButton.WidthPercent := 100.000000000000000000;
    SetEvent(ErrorsButton, Self, 'OnClick', 'ErrorsButtonClick');
    CompleteButton.SetParentComponent(Self);
    CompleteButton.Name := 'CompleteButton';
    CompleteButton.Left := 176;
    CompleteButton.Top := 256;
    CompleteButton.Width := 96;
    CompleteButton.Height := 25;
    CompleteButton.Caption := 'Completed!';
    CompleteButton.ChildOrder := 10;
    CompleteButton.ElementClassName := 'btn btn-primary';
    CompleteButton.ElementFont := efCSS;
    CompleteButton.ElementPosition := epIgnore;
    CompleteButton.Enabled := False;
    CompleteButton.HeightStyle := ssAuto;
    CompleteButton.HeightPercent := 100.000000000000000000;
    CompleteButton.WidthStyle := ssAuto;
    CompleteButton.WidthPercent := 100.000000000000000000;
    SetEvent(CompleteButton, Self, 'OnClick', 'CompleteButtonClick');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 48;
    CloseButton.Top := 256;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 9;
    CloseButton.ElementClassName := 'btn btn-secondary';
    CloseButton.ElementFont := efCSS;
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthStyle := ssAuto;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 480;
    WebMessageDlg1.Top := 176;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.HeightStyle := ssAuto;
    WebMessageDlg1.WidthStyle := ssAuto;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebMessageDlg1.ElementButtonClassName := 'btn';
    WebMessageDlg1.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg1.ElementTitleClassName := 'text-body';
    WebMessageDlg1.ElementContentClassName := 'text-body';
    DownloadFiles.SetParentComponent(Self);
    DownloadFiles.Name := 'DownloadFiles';
    DownloadFiles.Left := 48;
    DownloadFiles.Top := 344;
    DownloadFiles.Width := 227;
    DownloadFiles.Height := 113;
    DownloadFiles.HeightStyle := ssAuto;
    DownloadFiles.WidthStyle := ssAuto;
    DownloadFiles.ChildOrder := 19;
    DownloadFiles.ElementPosition := epIgnore;
    DownloadFiles.ElementFont := efCSS;
    DownloadFiles.Role := '';
    FileList.SetParentComponent(DownloadFiles);
    FileList.Name := 'FileList';
    FileList.Left := 44;
    FileList.Top := 29;
    FileList.Width := 129;
    FileList.Height := 60;
    FileList.Cursor := crHandPoint;
    FileList.HeightStyle := ssAuto;
    FileList.HeightPercent := 100.000000000000000000;
    FileList.WidthPercent := 100.000000000000000000;
    FileList.ChildOrder := 16;
    FileList.DefaultItemClassName := 'list-group-item';
    FileList.DefaultItemLinkClassName := 'list-group-link';
    FileList.ElementFont := efCSS;
    FileList.ElementPosition := epIgnore;
    FileList.ElementListClassName := 'list-group';
    FileList.Items.Clear;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 0';
    end;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 1';
    end;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 2';
    end;
    FileList.Style := lsListGroup;
    SetEvent(FileList, Self, 'OnItemClick', 'FileListItemClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.Left := 488;
    DataSource.Top := 112;
  finally
    CompletedBy.AfterLoadDFMValues;
    DateCompleted.AfterLoadDFMValues;
    OwnedBy.AfterLoadDFMValues;
    SubmittedBy.AfterLoadDFMValues;
    DateSubmitted.AfterLoadDFMValues;
    RunLevelLabel.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    DateRun.AfterLoadDFMValues;
    JobType.AfterLoadDFMValues;
    FormCaption.AfterLoadDFMValues;
    PlaceJobButton.AfterLoadDFMValues;
    ErrorMessage.AfterLoadDFMValues;
    ErrorsButton.AfterLoadDFMValues;
    CompleteButton.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    DownloadFiles.AfterLoadDFMValues;
    FileList.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
